<template>
  <div class="column content-box">
    <div class="node_name">
      <input
        v-model="node.data.customName"
        type="text"
        style="margin:0; margin-right:5px;text-transform: uppercase;"
        :placeholder="node.title"
        class="inputTitle"
      />
    </div>
    <form @submit.prevent>

      <InputField
        v-model="promptNode.prompt"
        :label="$t('FLOW.PROMPT.FORM.PROMPT.LABEL')"
        :placeholder="$t('FLOW.PROMPT.FORM.PROMPT.PLACEHOLDER')"
        type="textarea"
        :rows="5"
        :error="$v.promptNode.prompt.$error ? $t('FLOW.PROMPT.FORM.PROMPT.ERROR') : ''"
        @blur="$v.promptNode.prompt.$touch"
        />
        <!-- :error="$v.coupon.discount_value.$error ? $t('FLOW.PROMPT.FORM.PROMPT.ERROR') : ''"
        @blur="$v.coupon.discount_value.$touch" -->

        <MultiselectDropdown
        :label="$t('FLOW.PROMPT.FORM.MODEL.LABEL')"
        :error="$v.promptNode.model.$error ? $t('FLOW.PROMPT.FORM.MODEL.ERROR') : ''"
        >
             <multiselect
              class="column small-12"
              v-model="promptNode.model"
              :options="gptModels"
              track-by="id"
              label="id"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :hide-selected="true"
              :disabled="uiFlags.isModelFetching"
              :placeholder="$t('FLOW.PROMPT.FORM.MODEL.PLACEHOLDER')"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
              @close="$v.promptNode.model.$touch"
            />
        </MultiselectDropdown>
        <MultiselectDropdown
        :label="$t('FLOW.PROMPT.FORM.OUTPUT_TYPE.LABEL')"
        :error="$v.promptNode.format_type.$error ? $t('FLOW.PROMPT.FORM.OUTPUT_TYPE.ERROR') : ''"
        >
             <multiselect
              class="column small-12"
              v-model="promptNode.format_type"
              :options="resFormats"
              track-by="id"
              label="name"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :hide-selected="true"
              :disabled="false"
              :placeholder="$t('FLOW.PROMPT.FORM.OUTPUT_TYPE.PLACEHOLDER')"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
              @close="$v.promptNode.format_type.$touch"
            />
        </MultiselectDropdown>

        <!-- <pre>{{llmModels}}</pre> -->


      <div class="modal-footer">
        <woot-button @click.prevent="submitForm">{{ $t('FLOW.DONE') }}</woot-button>
        <!-- <woot-button variant="clear" @click.prevent="onClose">{{ $t('FLOW.CANCEL') }}</woot-button> -->
      </div>
    </form>
  </div>
</template>

<script>
import { url,required  } from 'vuelidate/lib/validators';
import alertMixin from 'shared/mixins/alertMixin';
import { Node } from '../../vue-diagram-editor/src';
import FluentIcon from '../../../../../../../shared/components/FluentIcon/Index.vue';
import InputField from 'components/ui/inputs/InputField.vue';
import MultiselectDropdown from "components/ui/inputs/MultiselectDropdown.vue";
import {LLM_RESPONSE_FORMAT} from "dashboard/routes/dashboard/settings/campaigns/llm_chatbot/llm.constant.js";
import { mapGetters } from 'vuex';



export default {
  name: 'PromptNode',
  components: {
    FluentIcon,
    InputField,
    MultiselectDropdown,
  },
  mixins: [alertMixin],
  props: {
    node: {
      type: Node,
      required: true,
    },
    dref: {
      required: true,
    },
    botid: {
      required: true,
    },
    profiles: {
      required: true,
    },
  },
  data() {
    return {
        resFormats: LLM_RESPONSE_FORMAT,
        // gptModels: [],
        promptNode:{
            prompt:"",
            model: null,
            format_type: null,
        }
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'llmbots/getUIFlags',
      gptModels: 'llmbots/getLLModels',
      currentUser: 'getCurrentUser',
    }),
  },
   validations() {
    return {
      promptNode: {
        prompt: { required },
        model: { required },
        format_type: { required },
      },
    };
  },
  mounted() {
    this.loadNodeData();
    this.fetchGptModels();
  },
  methods: {
    submitForm() {
        this.$v.$touch();

        if (this.$v.$invalid) {
            return;
        }

      const prevData = { ...this.node.data };
      prevData.contents = [
        {
          ...prevData.contents?.[0],
          prompt: this.promptNode.prompt,
          model: this.promptNode.model?.id || null,
          format_type: this.promptNode.format_type?.id || null,
        },
      ];

     this.dref.updateNode({
        id: this.node.id,
        name: 'data',
        value: prevData,
      });

      this.$emit('all-done');
    },
    loadNodeData() {
      const content = this.node.data.contents?.[0] || {};
      this.promptNode.prompt = content.prompt || '';

      // Prepopulate placeholders with null (until options loaded)
      this.promptNode.model = content.model
        ? { id: content.model }
        : null;

      this.promptNode.format_type = content.format_type
        ? this.resFormats.find((f) => f.id === content.format_type) || null
        : null;
    },
    async fetchGptModels() {
      this.$store.dispatch('llmbots/fetchLLMModels');
    },

  },
};
</script>

<style scoped lang="scss">
.node_name{
    display: flex; padding: 8px;
    padding-left: 24px;
    padding-right: 36px;
    color:grey;
    align-items: center;
}




</style>